import * as z from 'zod';

// We will use snake case in the metadata but it does not really matter.
const upstreamMetadataSchema = z.object({
  // ID of the hook integration that installed the extension & is responsible for updating
  hook_interface_id: z.number(),
  // The string identifier of the extension from the hook, like "kittens"
  // We will always be calling it "External ID" to distinguish it from the hook id
  external_hook_template_id: z.string(),
  // The installed version of the extension
  external_hook_template_version: z.string(),
});

type UpstreamMetadata = z.TypeOf<typeof upstreamMetadataSchema>;

export type Upstream = {
  hookInterfaceId: number;
  externalHookTemplateId: string;
  version: string;
};

export const toUpstreamMetadata = ({
  hookInterfaceId,
  externalHookTemplateId,
  version,
}: Upstream): UpstreamMetadata => ({
  hook_interface_id: hookInterfaceId,
  external_hook_template_id: externalHookTemplateId,
  external_hook_template_version: version,
});

export const fromUpstreamMetadata = (
  metadata: unknown
): Upstream | undefined => {
  const parsed = z
    .object({ upstream: upstreamMetadataSchema })
    .optional()
    .catch(undefined)
    .parse(metadata);

  return parsed
    ? {
        hookInterfaceId: parsed.upstream.hook_interface_id,
        externalHookTemplateId: parsed.upstream.external_hook_template_id,
        version: parsed.upstream.external_hook_template_version,
      }
    : undefined;
};
